import { render, staticRenderFns } from "./VonapToolbarLabel.vue?vue&type=template&id=5a4f3ece&scoped=true&"
import script from "./VonapToolbarLabel.vue?vue&type=script&lang=js&"
export * from "./VonapToolbarLabel.vue?vue&type=script&lang=js&"
import style0 from "./VonapToolbarLabel.vue?vue&type=style&index=0&id=5a4f3ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4f3ece",
  null
  
)

export default component.exports